export default __webpack_public_path__ + "static/media/lunge_walk_thumb.88bfd09c.png";